





















































































import Vue from 'vue';
import Component from 'vue-class-component';
import BindAttrs from '@/utils/binds-attrs';
import '@/compiled-icons/funnel';
import '@/compiled-icons/funnel-outline';
import AmetrasDynamicFieldWithAdvancedFilterTemplate from '../../fields/AmetrasDynamicFieldWithAdvancedFilterTemplate.vue';
import {Prop, Watch} from 'vue-property-decorator';
import {cloneDeep, toString} from 'lodash';
// import {AUTOFILL_SERVICE_INSTANCE} from '@/services/autofill.service';

@Component({
  components: {AmetrasDynamicFieldWithAdvancedFilterTemplate},
  mixins: [BindAttrs]
})
export default class DatatableHeaderWithSortingAndFiltering extends Vue {

  @Prop() tableConfiguration!: DisguiseDto.DTTemplateDto;
  @Prop() inputConfiguration!: DisguiseDto.DTInputConfigurationDto;

  activeSortColumns: { [key: string]: { direction: 'ASC' | 'DESC', rank: number } } = {}; // holds the ordered sort column indices. Relevant for multisort.

  // once the advanced filter button has been clicked, the columnindex will be set to open the adv. fitler dialog
  showAdvancedFilterDialogForColumnKey: string | null = null;

  @Watch('inputConfiguration') modelChanges(newValue: DisguiseDto.DTInputConfigurationDto) {
    this.activeSortColumns = this.defineActiveSortColumns(newValue.columns || []);
  }

  created() {
    let updateAdvancedFilter = false;
    const inputColumnConfiguration = cloneDeep(this.inputConfiguration.columns);
    for (const currentColumn of this.tableConfiguration.columns || []) {
      if (currentColumn.search) {
        if (currentColumn.key !== undefined && currentColumn.search.searchValues) {
          if (inputColumnConfiguration) {
            (inputColumnConfiguration.find((value) => value.key === currentColumn.key) || {}).searchValues = currentColumn.search.searchValues;
            (inputColumnConfiguration.find((value) => value.key === currentColumn.key) || {}).searchValue = '';
            updateAdvancedFilter = true;
          }
        }
      }
    }

    if (updateAdvancedFilter) {
      this.$emit('column-configuration-change', inputColumnConfiguration);
    }

    this.activeSortColumns = this.defineActiveSortColumns(this.tableConfiguration.columns || []);
  }

  /**
   * Handles the response from the advanced filter dialog.
   */
  applyAdvancedFilter(columnKey: string | null, searchValues: DisguiseDto.SearchValues[]) {
    const inputColumnConfiguration = cloneDeep(this.inputConfiguration.columns);
    if (inputColumnConfiguration) {
      (inputColumnConfiguration.find((value) => value.key === columnKey) || {}).searchValues = searchValues;
      (inputColumnConfiguration.find((value) => value.key === columnKey) || {}).searchValue = '';
      this.$emit('column-configuration-change', inputColumnConfiguration);
    }
    this.showAdvancedFilterDialogForColumnKey = null;
  }

  /**
   * Handles the response from the advanced filter dialog.
   */
  applySimpleFilter(columnKey: string | null, newSearchValue: string) {
    const inputColumnConfiguration = cloneDeep(this.inputConfiguration.columns);
    if (inputColumnConfiguration) {
      (inputColumnConfiguration.find((value) => value.key === columnKey) || {}).searchValues = undefined;
      (inputColumnConfiguration.find((value) => value.key === columnKey) || {}).searchValue = toString(newSearchValue);
      this.$emit('column-configuration-change', inputColumnConfiguration);

      // write simple filter changes to autofill
      if (newSearchValue !== undefined && newSearchValue !== null) {
        if (columnKey !== undefined) {
          for (const currentCol of this.tableConfiguration.columns || []) {
            if (currentCol.key === columnKey) {
              if (currentCol.autofillName !== undefined) {
                // save current values manually to autocomplete
                /*AUTOFILL_SERVICE_INSTANCE.saveAutofillValues([{
                  autofillName: currentCol.autofillName,
                  value: newSearchValue
                }]);*/
              }
            }
          }
        }
      }
    }
  }

  /* Sort */
  changeSort(column: DisguiseDto.DTColumnsDto) {
    if (!column.cellVisibility || column.cellVisibility.indexOf('FILTER_ROW') >= 0) {
      const inputColumnConfiguration = cloneDeep(this.inputConfiguration.columns);
      if (inputColumnConfiguration && this.tableConfiguration.sortOptions?.sortType !== 'NONE' && column.key !== undefined) {
        const activeSort = this.activeSortColumns[column.key];

        if (activeSort) {
          if (activeSort.direction === 'ASC') {
            // toggle
            activeSort.direction = 'DESC';
            (inputColumnConfiguration.find((value) => value.key === column.key) || {}).sort = 'DESC';
          } else {
            // remove
            const oldSortRank = activeSort.rank;
            delete this.activeSortColumns[column.key];
            delete (inputColumnConfiguration.find((value) => value.key === column.key) || {}).sort;
            delete (inputColumnConfiguration.find((value) => value.key === column.key) || {}).sortRank;

            if (this.tableConfiguration.sortOptions?.sortType === 'MULTI_SORT') {
              for (const activeSortColumnKey of Object.keys(this.activeSortColumns)) {
                const currentActiveSortColumn = this.activeSortColumns[activeSortColumnKey];
                if (currentActiveSortColumn.rank !== undefined && currentActiveSortColumn.rank >= oldSortRank) {
                  currentActiveSortColumn.rank = currentActiveSortColumn.rank - 1;
                }
              }
              for (const dtInputColumnDto of inputColumnConfiguration) {
                if (dtInputColumnDto.sortRank !== undefined && dtInputColumnDto.sortRank >= oldSortRank) {
                  dtInputColumnDto.sortRank = dtInputColumnDto.sortRank - 1;
                }
              }
            }
          }
        } else {
          let newActiveSortColumns = this.activeSortColumns;
          // add
          if (this.tableConfiguration.sortOptions?.sortType === 'SINGLE_SORT') {
            newActiveSortColumns = {};
            for (const currentInputConfiguration of inputColumnConfiguration) {
              delete currentInputConfiguration.sort;
              delete currentInputConfiguration.sortRank;
            }
          } else {
            const newRank = Object.keys(this.activeSortColumns).length;
            newActiveSortColumns[column.key] = {
              direction: 'ASC',
              rank: newRank
            };
            (inputColumnConfiguration.find((value) => value.key === column.key) || {}).sort = 'ASC';
            (inputColumnConfiguration.find((value) => value.key === column.key) || {}).sortRank = newRank;
          }
          this.activeSortColumns = newActiveSortColumns;
        }

        for (const currentColumnKey of Object.keys(this.activeSortColumns)) {
          const currentColumn = this.activeSortColumns[currentColumnKey];
          if ((inputColumnConfiguration.find((value) => value.key === currentColumnKey) || {}).sort) {
            (inputColumnConfiguration.find((value) => value.key === currentColumnKey) || {}).sortRank = currentColumn.rank;
          }
        }
      }
      this.$emit('column-configuration-change', inputColumnConfiguration);
    }
  }

  private defineActiveSortColumns(inputColumns: DisguiseDto.DTColumnsDto[]) {
    const colsWithSort: DisguiseDto.DTColumnsDto[] = inputColumns.filter(
        (value) => value.sort !== undefined
    ).sort((a, b) => (
        (a.sortRank || 0) < (b.sortRank || 0) ? -1 : 1)
    );
    const newActiveSortColumns: { [key: string]: { direction: 'ASC' | 'DESC', rank: number } } = {};
    for (const currentColumn of colsWithSort) {
      if (currentColumn.key !== undefined && currentColumn.sort !== undefined && currentColumn.sortRank !== undefined) {
        newActiveSortColumns[currentColumn.key] = {
          direction: currentColumn.sort,
          rank: currentColumn.sortRank
        };
      }
    }
    return newActiveSortColumns;
  }

}
